import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { AutoplayVariation, AutoplayABTestConfig } from '@/store/videoFeatures/types/autoplay-ab-test';
import { AutoplayABOrderCard } from './AutoplayABOrderCard';
import { DndContext, closestCenter, useSensor, useSensors, PointerSensor, DragEndEvent } from '@dnd-kit/core';
import { SortableContext, arrayMove, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { toast } from 'sonner';

interface AutoplayABOrderStepProps {
  variations: AutoplayVariation[];
  onUpdateConfig: (updates: Partial<AutoplayABTestConfig>) => void;
}

export function AutoplayABOrderStep({ variations, onUpdateConfig }: AutoplayABOrderStepProps) {
  useLanguage();
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 5 },
    })
  );

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    
    if (over && active.id !== over.id) {
      const oldIndex = variations.findIndex(v => v.id === active.id);
      const newIndex = variations.findIndex(v => v.id === over.id);
      const reorderedVariations = arrayMove(variations, oldIndex, newIndex);
      onUpdateConfig({ variations: reorderedVariations });
      toast.success(translateInterfaceText("Ordem atualizada"));
    }
  };

  return (
    <div className="space-y-4">
      {/* Sortable List */}
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={variations.map(v => v.id)}
          strategy={verticalListSortingStrategy}
        >
          <div className="space-y-4">
            {variations.map((variation, index) => (
              <AutoplayABOrderCard
                key={variation.id}
                variation={variation}
                orderIndex={index}
                isPrimary={index === 0}
              />
            ))}
          </div>
        </SortableContext>
      </DndContext>
    </div>
  );
}
